interface HighlightCardProps {
  icon: string;
  iconBgColor: string;
  iconColor: string;
  label: string;
  value: string | number;
  suffix?: string;
}

export function HighlightCard({
  icon,
  iconBgColor,
  iconColor,
  label,
  value,
  suffix,
}: HighlightCardProps) {
  return (
    <div className="rounded-4xl bg-[#1e1e1e] p-4 border border-white/5 flex flex-col items-center justify-center text-center gap-2">
      <div
        className="size-10 rounded-full flex items-center justify-center border"
        style={{
          backgroundColor: iconBgColor,
          borderColor: iconColor.replace("1)", "0.3)"),
          color: iconColor,
        }}
      >
        <span className="material-symbols-outlined">{icon}</span>
      </div>
      <div>
        <p className="text-xs text-white/50 font-medium">{label}</p>
        <p className="text-xl font-bold text-white">
          {value}{" "}
          {suffix && (
            <span className="text-sm text-white/40 font-normal">{suffix}</span>
          )}
        </p>
      </div>
    </div>
  );
}
